import React, { useState } from "react";
import { Minus, Plus } from "lucide-react";
import { HOUSING_FAQS } from "../../content/housingProgramGuideData";
import { guideBodyClass } from "./guideSection";

export default function HousingProgramFaq() {
  const [openQuestions, setOpenQuestions] = useState<Record<string, boolean>>({});

  function toggleQuestion(question: string) {
    setOpenQuestions((current) => ({
      ...current,
      [question]: !current[question],
    }));
  }

  return (
    <div className="flex flex-col divide-y divide-[#eadfd6] border-y border-[#eadfd6]">
      {HOUSING_FAQS.map((item, index) => {
        const isOpen = Boolean(openQuestions[item.question]);
        const answerId = `housing-faq-${index}`;

        return (
          <div key={item.question}>
            <button
              type="button"
              className="flex w-full items-center justify-between gap-3 py-3 text-left text-sm font-semibold text-[#1f2933]"
              aria-expanded={isOpen}
              aria-controls={answerId}
              onClick={() => toggleQuestion(item.question)}
            >
              {item.question}
              {isOpen ? (
                <Minus className="h-4 w-4 shrink-0 text-[#dd6435]" aria-hidden />
              ) : (
                <Plus className="h-4 w-4 shrink-0 text-[#dd6435]" aria-hidden />
              )}
            </button>
            {isOpen && (
              <p id={answerId} className={`${guideBodyClass} pb-3`}>
                {item.answer}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
